import * as React from 'react';
import {ColDef, DataGrid, ValueGetterParams} from '@material-ui/data-grid';
import {useDispatch, useSelector} from "react-redux";
import {RootState} from "../../Store/Reducers";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faEye} from "@fortawesome/free-solid-svg-icons";
import {ModalActions} from "../../Store/Modal/Slice";
import {SHIPPING_DETAIL_MODAL} from "../../Store/Modal/Types";

const ShipmentHistoryTableComponent = () => {

  const {ShipmentReducer: {deliveredShipment, shipments}} = useSelector((state: RootState) => state);

  const dispatch = useDispatch();

  const openShipmentDetailModal = (params: ValueGetterParams) => {
    const openPreviewModal = () => {
      const shipping = shipments?.find(s=>s._KEY === params.data.id);
      console.log(shipping);
      dispatch(ModalActions.openModal({modal: SHIPPING_DETAIL_MODAL, data: {shippingInfo:shipping}}))
    };
    return (
      <FontAwesomeIcon onClick={openPreviewModal} className="s-detail-icon" icon={faEye}/>
    );
  };

  const columns: ColDef[] = [
    {field: 'receiver', headerName: 'Quien recibe', width: 221},
    {field: 'pickup_date', headerName: 'Día de recogida', width: 221},
    {field: 'delivery_date', headerName: 'Día recibido', width: 221},
    {field: 'total_value', headerName: 'Valor total', width: 221},
    {field: '', headerName: 'Acciones', renderCell: openShipmentDetailModal, width: 221},
  ];


  return (
    <div style={{minHeight: 400, width: '100%'}}>
      <DataGrid rows={deliveredShipment}
                columns={columns}
                pageSize={5}/>
    </div>
  );
};

export default ShipmentHistoryTableComponent;
